
export const translateSpecialLink = function (intl, specialLinkType) {
  switch (specialLinkType) {
    case 3 :
      return intl.formatMessage({ id: 'Load.Common.PreferenceCenterLink' })
    case 2 :
      return intl.formatMessage({ id: 'Load.Common.ProfileUpdateFormLink' })
    case 5 :
      return intl.formatMessage({ id: 'Load.Common.SendToAFriendLink' })
    case 6 :
      return intl.formatMessage({ id: 'Load.Common.CondivisioneSocial' })
    case 1 :
      return intl.formatMessage({ id: 'Load.Common.UnsubscribeLink' })
    case 4 :
      return intl.formatMessage({ id: 'Load.Common.ViewInBrowserLink' })
    default :
      return null
  }
}

export const isSpecialLink = function (specialLinkType) {
  return specialLinkType && (specialLinkType !== 'GEN')
}
